

























import Vue from "vue";
import { mapState } from "vuex";
import { DocumentType } from "@/constants/form-values";
import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import NavigationButton from "@/components/basic/buttons/NavigationButton.vue";

export default Vue.extend({
  name: "UploadFailed",
  components: {
    SubmitButton,
    NavigationButton,
  },
  data() {
    return {
      DocumentType,
      TRANSLATION_KEY: "steps.UploadFailed",
    };
  },
  computed: {
    ...mapState({
      responseData: (state: any) => state.formData,
      isMobile: (state: any) => state.isDetectedMobileDevice,
    }),
  },
});
